export const hero = () => {
	const arrow = document.querySelector('.hero-horizon__scroll img');
    arrow && arrow.addEventListener('click', () => {
        if(window.matchMedia('(min-width: 992px)').matches) document.querySelector('.about-horizon').scrollIntoView({behavior: "smooth"})
        else document.querySelector('.carousel').scrollIntoView({behavior: "smooth"})
    })
}